import { FC, useMemo } from "react"
import { DLMROI } from "../../_models"
import { DetailCard, DetailItem, DetailFileDownload, DetailLabelKeysToCells, extractROIDetailFiles } from "../../../../../components/layout"
import { isPopulatedArray, showDate } from "../../../../../components/helpers"
import { PageViewLink } from "../../../../../components/widgets"
import { ApplicationAttachment } from "../../../applications"


const DLM_ROI_DETAILS_COMMON_FIELDS = {
  cbRef: "ROI Reference No",
  cocHolderRef: 'CoC Holder Ref',
  cocHolder: 'Coc Holder',
  cocHolderAddress: 'CoC Holder Address',
  installerCompany: 'Installer Company',
  cocNo: 'Certificate No',
  quantity: 'Labels Qty',
  brand: 'Brand',
  serial: 'Serial No',
  model: 'Model',
  country: 'Country of Origin',
  projectName: 'Project Name/Location',    
  planNo: 'SCDF Building Plan No',
  otherRef: 'Others Document Reference No.'        
}

type Props = {
  dlmAppId: number
  details: DLMROI & {
    policeReport?: ApplicationAttachment
    rois?: Array<DLMROI>
  }
  cardTitle?:string
}

const ROIDetails: FC<Props> = ({dlmAppId, details, cardTitle="ROI Details"}) => {
    
  const showFiles = useMemo(() => {
    if (details?.rois && details.rois.length > 0) {
      return extractROIDetailFiles(details.rois, dlmAppId);
    }
    return extractROIDetailFiles([details], dlmAppId);
  }, [dlmAppId, details]);
  
  return(
  <DetailCard cardTitle={cardTitle}>
    {DetailLabelKeysToCells(DLM_ROI_DETAILS_COMMON_FIELDS, details)}                
    { // @ts-ignore
    (details?.inspectionDate) && <DetailItem labelText="Inspection Date">{showDate(details.inspectionDate, 'inspectionDate')}</DetailItem>
    }
    { (details?.disclaimerAck) && 
    <DetailItem labelText="Disclaimer Acknowledged" >
      <div className='form-check form-check-sm form-check-custom form-check-solid'>
        <input className='form-check-input pe-none' type='checkbox' checked readOnly />
      </div>
    </DetailItem>
    }    
    { (details?.fromROI && details?.fromROI?.id > 0) && 
    <>
    <div className='separator border-gray-200 mb-2'></div>
    <DetailItem labelText="From ROI">      
        {(details.fromROI?.cbRef && details.fromROI.cbRef.length > 0) && 
        <>
        {details.fromROI.cbRef}
        &nbsp;
        </>
        }        
        <PageViewLink id={details.fromROI.id} pageType="dlmROI">(view)</PageViewLink>
    </DetailItem>
    </>    
    }    
    { ((details?.policeReport && details.policeReport?.id) || isPopulatedArray(showFiles)) && 
    <>
    <div className='separator border-gray-200 mb-2' />
    {(details?.policeReport && details.policeReport?.id) &&
    <DetailFileDownload labelText="Police Report" file={details.policeReport} setscoOnly />
    }   
    {
    showFiles.map((dat: any, idx: number) => (
    <DetailFileDownload key={`showfile${idx}`} labelText={dat.showFileTitle} file={dat.showFile} data={dat} />
    ))    
    }
    { (details?.issueDate) && 
    <DetailItem labelText="Issue Date">                    
      {showDate(details.issueDate, 'dateOnly')}
    </DetailItem>                
    }          
    </>    
    } 
    { 
    //@ts-ignore
    (details?.comment) && <> <div className='separator border-gray-200 mb-2'></div> <DetailItem labelText="Comment" content={details.comment} /> </>    
    } 
    { 
    //@ts-ignore
    (details?.otherAttachments && details.otherAttachments.length > 0) &&
    <>
    <label className="mt-4 fw-bold fs-5">Other Attachments</label>
    <div className="mh-150px overflow-auto pe-6 me-n4">
    { //@ts-ignore
    details.otherAttachments.map((file: any, idx: number) => (
      <DetailFileDownload key={`otherFile${idx}`} labelText={`File ${idx + 1}`} file={file}/>
    ))}
    </div>
    </>
    }            
  </DetailCard>          
  )
}
    
export { ROIDetails }